import { jsx } from "react/jsx-runtime";
import BugReportIcon from "@mui/icons-material/BugReport";
import { validateTidalLicense } from "../../base/index.js";
function BugReport(props) {
  return /* @__PURE__ */ jsx(
    BugReportIcon,
    {
      "data-testid": "BugReport",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "BugReport",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
BugReport.tidalIconMeta = {
  categories: "miscellaneous",
  name: "BugReport"
};
validateTidalLicense();
export {
  BugReport
};
//# sourceMappingURL=BugReport.js.map
